import { DateService } from './../services/date.service';
import { DatePipe } from '@angular/common';
import { Component, Injectable, NgZone, OnInit } from '@angular/core';
import {
  NgbCalendar,
  NgbDate,
  NgbDateAdapter,
  NgbDateParserFormatter,
  NgbDatepickerConfig,
  NgbDateStruct,
} from '@ng-bootstrap/ng-bootstrap';
import { ReportService } from '../services/report.service';
import * as XLSX from 'xlsx';
import { AppStateProvider } from '../providers/app-state.provider';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import { Workbook } from 'exceljs';

/**
 * This Service handles how the date is represented in scripts i.e. ngModel.
 */
@Injectable()
export class CustomAdapter extends NgbDateAdapter<string> {
  readonly DELIMITER = '-';

  fromModel(value: string | null): NgbDateStruct | null {
    if (value) {
      let date = value.split(this.DELIMITER);
      return {
        day: parseInt(date[0], 10),
        month: parseInt(date[1], 10),
        year: parseInt(date[2], 10),
      };
    }
    return null;
  }

  toModel(date: NgbDateStruct | null): string | null {
    return date
      ? date.day + this.DELIMITER + date.month + this.DELIMITER + date.year
      : null;
  }
}

/**
 * This Service handles how the date is rendered and parsed from keyboard i.e. in the bound input field.
 */
@Injectable()
export class CustomDateParserFormatter extends NgbDateParserFormatter {
  readonly DELIMITER = '/';

  parse(value: string): NgbDateStruct | null {
    if (value) {
      let date = value.split(this.DELIMITER);
      return {
        day: parseInt(date[0], 10),
        month: parseInt(date[1], 10),
        year: parseInt(date[2], 10),
      };
    }
    return null;
  }

  format(date: NgbDateStruct | null): string {
    return date
      ? date.day + this.DELIMITER + date.month + this.DELIMITER + date.year
      : '';
  }
}
@Component({
  standalone: false,
  selector: 'app-reports',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.scss'],
})
export class ReportsComponent implements OnInit {
  worksheet;
  workbook;
  searchText: string = '';
  isDesc: boolean = false;
  column: string = 'MeetingRoom';
  selectedDate: any;
  selectedIndex: number;
  selectedMeetingRoomId: any;
  selectedDepartmentId: any;
  selectedAccessPointId: any;
  selectedMeetingRoom: any;
  selectedUsageType: any;
  selectedUsageTypeId: any;
  selectedDepartment: any;
  selectedAccessPoint: any;
  selectedToDate: string;

  meetingRooms: any;
  accessPoints: any;
  departments: any;
  creditPoints: any = [];
  checkIns: any = [];
  checkIn: any = [];
  employees: any = [];
  meetings: any = [];
  meeting: any = [];

  meetingNav: { index: string; name: string; link: string }[];
  toDate: any;
  fromDate: any;
  EXCEL_EXTENSION = '.xlsx';
  EXCEL_TYPE =
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
  reportsFetched: boolean = false;
  reportsLoaded: boolean = false;
  multiSelectionMeetingRoom: any = [];
  Usagetypes: any = [];
  DownloadTypes: any = [];
  SelectedDownloadReportType: any = [];
  page: any;
  multiSelectionDepartments: any = [];
  multiSelectionAccessPoints: any = [];
  multiSelectionCreditUsageType: any = [];
  meetingRoom: any;
  pageSize: number = 10;
  department: any;
  accessPoint: any;
  creditPoint: any;
  employee: any;
  selctionlength: number;
  PdfReportrows = [];
  Createdby: number;
  fromDetails: boolean = false;
  hour: any;
  min: any;
  meridiem: string;
  time: string;
  fDate: string;
  tDate: string;
  formattedSelectedToDate: string = "";
  formattedSelectedDate: string = '';

  constructor(
    public datepipe: DatePipe,
    private reportService: ReportService,
    private appStateSrv: AppStateProvider,
    private zone: NgZone,
    private dateAdapter: NgbDateAdapter<string>,
    private ngbCalendar: NgbCalendar,
    private ngbDatepickerConfig: NgbDatepickerConfig,
    private dateSrv: DateService
  ) {
    this.DownloadTypes = [
      { id: '1', type: 'Download as PDF' },
      { id: '2', type: 'Download as Excel' },
    ];
    ngbDatepickerConfig.minDate = {
      year: 1970, month: 1, day: 1
    };

    ngbDatepickerConfig.outsideDays = 'visible';
  }

  public async updateSelectedDate(date: NgbDate) {
    const jsDate = new Date(date.year, date.month - 1, date.day);
    const delay = (ms) => new Promise((res) => setTimeout(res, ms));

    this.fromDate = jsDate;
    // this.fromDate = this.updateDateToCalendar(date);
    this.fDate = this.updateDateToCalendar(date);
    this.selectedDate = this.datepipe.transform(jsDate, 'MM/dd/yyyy');
    this.formattedSelectedDate = this.dateSrv.convertDateToLocaleString(date.day, date.month - 1, date.year)
    if (this.fromDate && this.toDate) {
      if (this.fromDate <= this.toDate) {
        if (this.selectedIndex == 0) {
          this.getCreditReports(this.multiSelectionCreditUsageType[0]);
        }
        if (this.selectedIndex == 1) {
          this.getCheckInReports();
        } else if (this.selectedIndex == 2) {
          this.getEmployeeReports();
        } else if (this.selectedIndex == 3) {
          this.getMeetingReports();
        } else if (this.selectedIndex == 4) {
          this.getMeetingReports();
        }
      } else {
        this.zone.run(() => {
          this.selectedDate = this.datepipe.transform(new Date(), 'MM/dd/yyyy');
          this.formattedSelectedDate = this.dateSrv.convertDateToLocaleString(new Date().getDate(), new Date().getMonth(), new Date().getFullYear())
          // this.selectedReportType(localStorage.getItem('temp'))
          // this.selectedReportType(this.selectedIndex);
        });
        this.appStateSrv.showToast(
          'From date should not be greater than to date'
        );
        await delay(2000);
        this.resetDate(this.selectedIndex);
      }
    } else {
      this.appStateSrv.showToast('Please select from and to date');
    }
  }

  updateDateToCalendar(date?: NgbDate) {
    const updatedDate =
      date == undefined
        ? this.dateAdapter.toModel(this.ngbCalendar.getToday())!
        : this.dateAdapter.toModel(date)!;
    return updatedDate;
  }
  public async updateSelectedToDate(date: NgbDate) {
    const delay = (ms) => new Promise((res) => setTimeout(res, ms));

    const jsDate = new Date(date.year, date.month - 1, date.day);
    this.toDate = jsDate;
    this.tDate = this.updateDateToCalendar(date);
    this.selectedToDate = this.datepipe.transform(jsDate, 'MM/dd/yyyy');
    this.formattedSelectedToDate = this.dateSrv.convertDateToLocaleString(date.day, date.month - 1, date.year)

    if (this.fromDate && this.toDate) {
      if (this.fromDate <= this.toDate) {
        if (this.selectedIndex == 0) {
          if (this.multiSelectionCreditUsageType[0] == 2) {
            this.Createdby = null;
          }

          this.getCreditReports(this.multiSelectionCreditUsageType[0]);
        }
        if (this.selectedIndex == 1) {
          this.getCheckInReports();
        } else if (this.selectedIndex == 2) {
          this.getEmployeeReports();
        } else if (this.selectedIndex == 3) {
          this.getMeetingReports();
        } else if (this.selectedIndex == 4) {
          this.getMeetingReports();
        }
      } else {
        this.selectedDate = this.datepipe.transform(new Date(), 'MM/dd/yyyy'); 2
        this.formattedSelectedDate = this.dateSrv.convertDateToLocaleString(new Date().getDate(), new Date().getMonth(), new Date().getFullYear())


        this.appStateSrv.showToast(
          'From date should not be greater than to date'
        );
        await delay(2000);
        this.resetDate(this.selectedIndex);
        // this.selectedReportType(this.selectedIndex)
      }
    } else {
      this.appStateSrv.showToast('Please select from and to date');
    }
  }
  sort(property, list) {
    this.isDesc = !this.isDesc; //change the direction
    this.column = property;
    let direction = this.isDesc ? 1 : -1;

    let sortedArray = list.sort(function (a, b) {
      if (a[property] < b[property]) {
        return -1 * direction;
      } else if (a[property] > b[property]) {
        return 1 * direction;
      } else {
        return 0;
      }
    });
    return sortedArray;
  }
  onClickedOutside(e: Event) {
    console.log('Clicked outside:', e);
  }

  openPopover(popover) {
    if (popover.isOpen()) {
      popover.close();
    } else {
      popover.open();
    }

    // if (this.selectedIndex == 1) {
    //   this.getAccessPoints();
    //   this.getCheckInReports();
    // }
    // else if (this.selectedIndex == 2) {
    //   this.getDepartments();
    //   this.getEmployeeReports();
    // }
    // else if (this.selectedIndex == 3) {
    //   this.getMeetingRooms();
    //   this.getMeetingReports();
    // }
    // else if (this.selectedIndex == 4) {
    //   this.getCreditReports();
    // }
  }

  selectedReportDownload(item) {
    this.SelectedDownloadReportType = [];
    if (item.id !== null) {
      this.SelectedDownloadReportType.push(item.id);
    } else {
      this.SelectedDownloadReportType.push(1);
    }
    if (item.id == 2) {
      this.DownloadReport();
    } else if (item.id == 1) {
      this.DownloadReportPDF();
    }
  }
  selectedReportType(item) {
    this.searchText = '';
    this.Createdby = null;
    this.page = 1;
    this.selectedIndex = item;
    // localStorage.setItem('temp', item);
    if (this.selectedIndex == 1) {
      this.resetDate(1);
      this.getAccessPoints();
      this.getCheckInReports();
    } else if (this.selectedIndex == 2) {
      this.resetDate(2);
      this.getDepartments();
      this.getEmployeeReports();
    } else if (this.selectedIndex == 3) {
      this.resetDate(3);
      this.getMeetingRooms();
      this.getMeetingReports();
    } else if (this.selectedIndex == 4) {
      this.resetDate(4);
      this.multiSelectionMeetingRoom = [];
      this.getMeetingRooms();
      this.getMeetingReports();
    } else if (this.selectedIndex == 0) {
      this.resetDate(0);
      this.multiSelectionCreditUsageType = [];
      this.Usagetypes = [
        { id: '2', type: 'Admin(s)' },
        { id: '3', type: 'Employee(s)' },
      ];
      this.multiSelectionCreditUsageType.push(this.Usagetypes[0].id);
      // this.selectedAccessPointId = item.id;
      // this.selctionlength=this.multiSelectionCreditUsageType.length-1
      this.selectedUsageType = this.Usagetypes[0].type;
      this.getCreditReports(1);
    }
  }

  selectAccessPoint(item) {
    if (item.id !== null)
      if (this.multiSelectionAccessPoints.includes(item.id))
        this.multiSelectionAccessPoints.splice(
          this.multiSelectionAccessPoints.indexOf(item.id),
          1
        );
      else this.multiSelectionAccessPoints.push(item.id);
    else this.multiSelectionAccessPoints = [];

    this.selctionlength = this.multiSelectionAccessPoints.length - 1;
    this.selectedAccessPointId = item.id;

    if (item.department != 'All') {
      this.selectedAccessPoint = this.accessPoints.find(
        (x) =>
          x.id ==
          this.multiSelectionAccessPoints[
          this.multiSelectionAccessPoints.length - 1
          ]
      ).accessPointName;
    } else {
      this.selectedAccessPoint = item.accessPointName;
    }

    this.getCheckInReports();
  }

  selectCreditUsage(item) {
    this.searchText = '';
    if (item.id == 2) {
      this.Createdby = null;
    }
    this.multiSelectionCreditUsageType = [];
    if (item.id !== null) {
      this.multiSelectionCreditUsageType.push(item.id);
    } else this.multiSelectionCreditUsageType.push(1);
    // this.selectedAccessPointId = item.id;
    // this.selctionlength=this.multiSelectionCreditUsageType.length-1
    this.selectedUsageType = item.type;
    this.getCreditReports(item.id);
  }

  selectDepartment(item) {
    if (item.id !== null)
      if (this.multiSelectionDepartments.includes(item.id))
        this.multiSelectionDepartments.splice(
          this.multiSelectionDepartments.indexOf(item.id),
          1
        );
      else this.multiSelectionDepartments.push(item.id);
    else this.multiSelectionDepartments = [];

    //console.log('multiSelectionDepartments', this.multiSelectionDepartments);
    let length = this.multiSelectionDepartments.length - 1;
    this.selctionlength = length;
    this.selectedDepartmentId = item.id;

    if (item.department != 'All') {
      this.selectedDepartment = this.departments.find(
        (x) =>
          x.id ==
          this.multiSelectionDepartments[
          this.multiSelectionDepartments.length - 1
          ]
      ).department;
    } else {
      this.selectedDepartment = item.department;
    }

    this.getEmployeeReports();
  }

  selectMeetingRoom(item) {
    if (item.id !== null)
      if (this.multiSelectionMeetingRoom.includes(item.id))
        this.multiSelectionMeetingRoom.splice(
          this.multiSelectionMeetingRoom.indexOf(item.id),
          1
        );
      else this.multiSelectionMeetingRoom.push(item.id);
    else this.multiSelectionMeetingRoom = [];

    let length = this.multiSelectionMeetingRoom.length - 1;
    this.selctionlength = length;
    this.selectedMeetingRoomId = item.id;

    if (item.name != 'All') {
      this.selectedMeetingRoom = this.meetingRooms.find(
        (x) =>
          x.id ==
          this.multiSelectionMeetingRoom[
          this.multiSelectionMeetingRoom.length - 1
          ]
      ).name;
    } else {
      this.selectedMeetingRoom = item.name;
    }
    this.getMeetingReports();
  }
  reportsList = [
    {
      index: '0',
      type: 'Credit Usage Report',
    },
    {
      index: '1',
      type: 'Check-in Report',
    },
    {
      index: '2',
      type: 'Employee Detail Report',
    },
    {
      index: '3',
      type: 'Meeting Room - Employee Report',
    },
    {
      index: '4',
      type: 'Meeting Room - Admin Report',
    },
  ];

  ngOnInit(): void {
    this.meetingNav = [
      {
        index: '4',
        name: 'Reports',
        link: '/reports',
      },
    ];

    const route = {
      index: '4',
      name: 'Reports',
      link: '/reports',
    };
    this.appStateSrv.setSideNavState(route);

    const jsDate = new Date();
    this.selectedDate = this.datepipe.transform(jsDate, 'MM/dd/yyyy');
    this.formattedSelectedDate = this.dateSrv.convertDateToLocaleString(new Date().getDate(), new Date().getMonth(), new Date().getFullYear())

    this.selectedToDate = this.datepipe.transform(jsDate, 'MM/dd/yyyy');
    this.formattedSelectedToDate = this.dateSrv.convertDateToLocaleString(new Date().getDate(), new Date().getMonth(), new Date().getFullYear())

    this.fromDate = new Date(jsDate.toLocaleDateString('en-US'));
    this.toDate = new Date(jsDate.toLocaleDateString('en-US'));

    this.fDate = this.updateDateToCalendar();
    this.tDate = this.updateDateToCalendar();
    if (
      localStorage.getItem('reportQuery') == null ||
      localStorage.getItem('temp') != null
    ) {
      this.fromDetails = true;
    }

    if (
      localStorage.getItem('reportQuery') == null &&
      localStorage.getItem('temp') == null
    ) {
      this.Createdby = null;
      this.selectedIndex = 3;
      // localStorage.setItem('temp', '3');
      this.getMeetingRooms();
    } else {
      const queryData = JSON.parse(localStorage.getItem('reportQuery'));
      const tempData = localStorage.getItem('temp');
      // this.fromDetails = false;

      this.selectedToDate = queryData
        ? queryData.toDate
        : new Date().getMonth() +
        1 +
        '/' +
        new Date().getDate() +
        '/' +
        new Date().getFullYear();
      this.formattedSelectedToDate = queryData ? this.dateSrv.convertDateToLocaleString(queryData.toDate.split('/')[1], queryData.toDate.split('/')[0] - 1, queryData.toDate.split('/')[2]) : this.dateSrv.convertDateToLocaleString(new Date().getDate(), new Date().getMonth(), new Date().getFullYear());

      this.selectedDate = queryData
        ? queryData.fromDate
        : new Date().getMonth() +
        1 +
        '/' +
        new Date().getDate() +
        '/' +
        new Date().getFullYear();
      this.formattedSelectedDate = queryData ? this.dateSrv.convertDateToLocaleString(queryData.fromDate.split('/')[1], queryData.fromDate.split('/')[0] - 1, queryData.fromDate.split('/')[2]) : this.dateSrv.convertDateToLocaleString(new Date().getDate(), new Date().getMonth(), new Date().getFullYear());

      this.Createdby = queryData
        ? queryData.select == 'All'
          ? null
          : queryData.select
        : null;
      const type = queryData ? queryData.type : Number(tempData);

      if (queryData != null && queryData.UsageTypeId != null) {
        this.selectedUsageTypeId = queryData ? queryData.UsageTypeId : 1;
      } else {
        this.selectedUsageTypeId = 1;
      }

      switch (type) {
        case 0:
          this.selectedIndex = 0;

          this.getCreditReports(this.selectedUsageTypeId == 1 ? 3 : 2);
          localStorage.removeItem('reportQuery');
          localStorage.removeItem('temp');
          this.multiSelectionCreditUsageType = [];
          this.Usagetypes = [
            { id: '2', type: 'Admin(s)' },
            { id: '3', type: 'Employee(s)' },
          ];
          this.multiSelectionCreditUsageType.push(
            this.Usagetypes[this.selectedUsageTypeId].id
          );
          this.selectedUsageType =
            this.Usagetypes[this.selectedUsageTypeId].type;
          break;
        case 1:
          this.selectedIndex = 1;

          this.getAccessPoints();
          this.getCheckInReports();
          localStorage.removeItem('reportQuery');
          localStorage.removeItem('temp');
          break;
        case 2:
          this.selectedIndex = 2;

          this.getDepartments();
          this.getEmployeeReports();
          localStorage.removeItem('reportQuery');
          localStorage.removeItem('temp');

          break;
        case 3:
          this.selectedIndex = 3;

          this.getMeetingRooms();
          this.getMeetingReports();
          localStorage.removeItem('reportQuery');
          localStorage.removeItem('temp');

          break;
        case 4:
          this.selectedIndex = 4;

          this.getMeetingRooms();
          this.getMeetingReports();
          localStorage.removeItem('reportQuery');
          localStorage.removeItem('temp');

          break;
        default:
          this.selectedIndex = 3;
          this.getMeetingRooms();
          this.getMeetingReports();
      }
    }
  }

  getMeetingRooms() {
    this.reportsLoaded = false;
    this.reportService.getMeetingRooms().subscribe((r) => {
      this.meetingRooms = r;
      this.selectedMeetingRoomId = null;
      const allOpt = {
        id: null,
        name: 'All',
      };
      this.meetingRooms.unshift(allOpt);

      if (this.selectedMeetingRoomId == null && this.meetingRooms.length > 0) {
        this.selectedMeetingRoomId = this.meetingRooms[0].id;
        this.selectMeetingRoom(this.meetingRooms[0]);
      }
      this.reportsLoaded = true;
    });
  }

  getAccessPoints() {
    this.reportsLoaded = false;
    this.accessPoints = [];
    this.reportService.getAccessPoints().subscribe((r) => {
      this.accessPoints = r;
      const allOpt = {
        id: null,
        accessPointName: 'All',
      };
      this.accessPoints.unshift(allOpt);
      if (this.selectedAccessPointId == null && this.accessPoints.length > 0) {
        this.selectedAccessPointId = this.accessPoints[0].id;
        this.selectAccessPoint(this.accessPoints[0]);
      }
      this.reportsLoaded = true;
    });
  }

  getDepartments() {
    this.reportsLoaded = false;
    this.reportService.getDepartments().subscribe((r) => {
      this.departments = r;
      const allOpt = {
        id: null,
        department: 'All',
      };
      this.departments.unshift(allOpt);
      if (this.selectedDepartmentId == null && this.departments.length > 0) {
        this.selectedDepartmentId = this.departments[0].id;
        this.selectDepartment(this.departments[0]);
      }
      this.reportsLoaded = true;
    });
  }

  getCheckInReports() {
    this.reportsLoaded = false;
    this.checkIns = [];
    if (this.multiSelectionAccessPoints.length > 0) {
      this.reportService
        .getCheckInReports(
          this.multiSelectionAccessPoints,
          this.selectedDate,
          this.selectedToDate,
          this.Createdby
        )
        .subscribe((r) => {
          if (r.length > 0) this.checkIns = [...this.checkIns, ...r];
          this.reportsLoaded = true;
          this.handlePageChangeCheckIn(1);
        });
    } else
      this.reportService
        .getCheckInReports(
          this.multiSelectionAccessPoints,
          this.selectedDate,
          this.selectedToDate,
          this.Createdby
        )
        .subscribe((r) => {
          if (r.length > 0) this.checkIns = [...r];
          this.reportsLoaded = true;
          this.handlePageChangeCheckIn(1);
        });
  }

  getCreditReports(id) {
    this.reportsLoaded = false;
    this.reportService
      .getCreditReports(
        this.selectedDate,
        this.selectedToDate,
        id,
        this.Createdby
      )
      .subscribe((r) => {
        this.creditPoints = r;
        this.reportsLoaded = true;
        this.handlePageChangeCredit(1);
      });
  }

  getEmployeeReports() {
    this.reportsLoaded = false;
    this.employees = [];
    if (this.multiSelectionDepartments.length > 0) {
      this.reportService
        .getEmployeeReports(
          this.multiSelectionDepartments,
          this.selectedDate,
          this.selectedToDate
        )
        .subscribe((r) => {
          if (r.length > 0) this.employees = [...this.employees, ...r];
          this.reportsLoaded = true;
          this.handlePageChangeEmployee(1);
        });
    } else
      this.reportService
        .getEmployeeReports(null, this.selectedDate, this.selectedToDate)
        .subscribe((r) => {
          if (r.length > 0) this.employees = [...r];

          this.reportsLoaded = true;
          this.handlePageChangeEmployee(1);
        });
  }

  getMeetingReports() {
    this.reportsLoaded = false;
    this.meetings = [];
    let meetingRoomIdList: any[] = [];
    if (this.multiSelectionMeetingRoom.length > 0) {
      this.reportService
        .getMeetingReports(
          this.multiSelectionMeetingRoom,
          this.selectedDate,
          this.selectedToDate,
          this.selectedIndex == 4 ? 2 : 3,
          this.Createdby
        )
        .subscribe((r) => {
          if (r.length > 0) this.meetings = [...this.meetings, ...r];
          this.reportsLoaded = true;
          this.handlePageChangeMeeting(1);
        });
    } else
      this.reportService
        .getMeetingReports(
          null,
          this.selectedDate,
          this.selectedToDate,
          this.selectedIndex == 4 ? 2 : 3,
          this.Createdby
        )
        .subscribe((r) => {
          if (r.length > 0) this.meetings = [...r];
          this.reportsLoaded = true;
          this.handlePageChangeMeeting(1);
        });
  }

  refreshPagination(e) {
    this.page = e;
  }

  DownloadReport() {
    this.worksheet = null;
    let reportname;
    if (this.selectedIndex == 0) {
      this.workbook = new Workbook();
      if (this.multiSelectionCreditUsageType == 3) {
        reportname = 'CreditUsage-Employee(s) Report';
        this.worksheet = this.workbook.addWorksheet(reportname);
        this.worksheet.columns = [
          { header: 'Sr.No', key: 'SrNo', width: 10 },
          { header: 'Employee Name', key: 'EmployeeName', width: 10 },
          { header: 'Meeting Room Name', key: 'MeetingRoomName', width: 10 },
          { header: 'Date', key: 'DateOfMeeting', width: 10 },
          { header: 'Duration', key: 'Duration', width: 10 },
          { header: 'Credit points used', key: 'CreditPointsUsed', width: 10 },
          { header: 'Status', key: 'Status', width: 10 },
        ];
      } else {
        reportname = 'CreditUsage-Admin(s) Report';
        this.worksheet = this.workbook.addWorksheet(reportname);
        this.worksheet.columns = [
          { header: 'Sr.No', key: 'SrNo', width: 10 },
          { header: 'Admin Name', key: 'BookedBy', width: 10 },
          { header: 'Employee Name', key: 'EmployeeName', width: 10 },
          { header: 'Meeting Room Name', key: 'MeetingRoomName', width: 10 },
          { header: 'Date', key: 'DateOfMeeting', width: 10 },
          { header: 'Duration', key: 'Duration', width: 10 },
          { header: 'Credit points used', key: 'CreditPointsUsed', width: 10 },
          { header: 'Status', key: 'Status', width: 10 },
        ];
      }
      let data;

      data = this.creditPoints;
      data.forEach((e) => {
        this.worksheet.addRow(
          {
            SrNo: e.srNo,
            MeetingRoomName: e.meetingRoomName,
            BookedBy: e.bookedBy,
            DateOfMeeting: e.dateOfMeeting,
            Duration: e.duration,
            EmployeeName: e.employeeName,
            CreditPointsUsed: e.creditPointsUsed,
            Status: e.status,
          },
          'n'
        );
      });
      this.exportExcel(this.workbook, data, reportname);
    } else if (this.selectedIndex == 1) {
      //this.exportAsExcelFile(this.checkIns, 'CheckIn');
      this.workbook = new Workbook();
      reportname = 'CheckIn Report';
      this.worksheet = this.workbook.addWorksheet(reportname);
      this.worksheet.columns = [
        { header: 'Sr.No', key: 'SrNo', width: 10 },
        { header: 'Member Name', key: 'memberName', width: 10 },
        { header: 'Department', key: 'designationName', width: 10 },
        { header: 'Access Point', key: 'accessPointName', width: 10 },
        { header: 'Date', key: 'date', width: 10 },
        { header: 'Check-in Time', key: 'timeOfCheckIn', width: 10 },
      ];
      let data;
      data = this.checkIns;
      data.forEach((e) => {
        this.worksheet.addRow(
          {
            SrNo: e.srNo,
            designationName: e.designationName,
            accessPointName: e.accessPointName,
            date: e.date,
            timeOfCheckIn: e.timeOfCheckIn,
          },
          'n'
        );
      });
      this.exportExcel(this.workbook, data, reportname);
    } else if (this.selectedIndex == 2) {
      this.workbook = new Workbook();
      reportname = 'Employee Details Report';
      this.worksheet = this.workbook.addWorksheet(reportname);
      this.worksheet.columns = [
        { header: 'Sr.No', key: 'SrNo', width: 10 },
        { header: 'Member Name', key: 'memberName', width: 10 },
        { header: 'Department', key: 'department', width: 10 },
        { header: 'Onboarded Since', key: 'onBoardDate', width: 10 },
        { header: 'Ph Number', key: 'phoneNumber', width: 10 },
        { header: 'Email', key: 'email', width: 10 },
      ];
      let data;
      data = this.employees;
      data.forEach((e) => {
        this.worksheet.addRow(
          {
            SrNo: e.srNo,
            memberName: e.memberName,
            department: e.department,
            onBoardDate: e.onBoardDate,
            phoneNumber: e.phoneNumber,
            email: e.email,
          },
          'n'
        );
      });
      this.exportExcel(this.workbook, data, reportname);
      //this.exportAsExcelFile(this.employees, 'Employee');
    } else if (this.selectedIndex == 3) {
      //this.exportAsExcelFile(this.meetings, 'Meeting');
      this.workbook = new Workbook();
      reportname = 'Meeting Room Employee Report';
      this.worksheet = this.workbook.addWorksheet(reportname);
      this.worksheet.columns = [
        { header: 'Sr.No', key: 'SrNo', width: 10 },
        { header: 'Meeting Room', key: 'meetingRoomName', width: 10 },
        { header: 'Membership type', key: 'userType', width: 10 },
        { header: 'Organization Name', key: 'organisation', width: 10 },
        { header: 'Member Name', key: 'employeeName', width: 10 },
        { header: 'Date', key: 'dateOfMeeting', width: 10 },
        { header: 'Start Time', key: 'startTime', width: 10 },
        { header: 'Duration', key: 'duration', width: 10 },
        { header: 'Status', key: 'status', width: 10 },
      ];
      let data;
      data = this.meetings;
      data.forEach((e) => {
        this.worksheet.addRow(
          {
            SrNo: e.srNo,
            meetingRoomName: e.meetingRoomName,
            userType: e.userType,
            organisation: e.organisation,
            employeeName: e.employeeName,
            dateOfMeeting: e.dateOfMeeting,
            startTime: e.startTime,
            duration: e.duration + ' ' + 'hours',
            status: e.status,
          },
          'n'
        );
      });
      this.exportExcel(this.workbook, data, reportname);
    } else if (this.selectedIndex == 4) {
      this.workbook = new Workbook();
      reportname = 'Meeting Room Admin Report';
      this.worksheet = this.workbook.addWorksheet(reportname);
      this.worksheet.columns = [
        { header: 'Sr.No', key: 'SrNo', width: 10 },
        { header: 'Meeting Room', key: 'meetingRoomName', width: 10 },
        { header: 'Membership type', key: 'userType', width: 10 },
        { header: 'Organization Name', key: 'organisation', width: 10 },
        { header: 'Admin Name', key: 'bookedBy', width: 10 },
        { header: 'Member Name', key: 'employeeName', width: 10 },
        { header: 'Date', key: 'dateOfMeeting', width: 10 },
        { header: 'Start Time', key: 'startTime', width: 10 },
        { header: 'Duration', key: 'duration', width: 10 },
        { header: 'Status', key: 'status', width: 10 },
      ];
      let data;
      data = this.meetings;
      data.forEach((e) => {
        this.worksheet.addRow(
          {
            SrNo: e.srNo,
            bookedBy: e.bookedBy,
            meetingRoomName: e.meetingRoomName,
            userType: e.userType,
            organisation: e.organisation,
            employeeName: e.employeeName,
            dateOfMeeting: e.dateOfMeeting,
            startTime: e.startTime,
            duration: e.duration + ' ' + 'hours',
            status: e.status,
          },
          'n'
        );
      });
      this.exportExcel(this.workbook, data, reportname);
    }
  }
  exportExcel(workbook, data, ReportName) {
    workbook.xlsx.writeBuffer().then((data) => {
      let blob = new Blob([data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = ReportName;
      a.click();
      URL.revokeObjectURL(url);
    });
  }

  DownloadReportPDF() {
    this.PdfReportrows = [];

    if (this.selectedIndex == 0) {
      let head;
      if (this.multiSelectionCreditUsageType == 3) {
        head = [
          [
            'Sr.No',
            'Employee Name',
            'Meeting Room Name',
            'Date',
            'Duration',
            'Credit points used',
            'Status',
          ],
        ];
        this.creditPoints.forEach((element) => {
          var temp = [
            element.srNo,
            element.employeeName,
            element.meetingRoomName,
            element.dateOfMeeting,
            element.duration + ' ' + 'hours',
            element.creditPointsUsed,
            element.status,
          ];
          this.PdfReportrows.push(temp);
        });
        this.openPDF(
          this.PdfReportrows,
          'CreditPoint Employee(s) Report',
          head,
          'p'
        );
      } else if (this.multiSelectionCreditUsageType == 2) {
        head = [
          [
            'Sr.No',
            'Admin Name',
            'Employee Name',
            'Meeting Room Name',
            'Date',
            'Duration',
            'Credit points used',
            'Status',
          ],
        ];
        this.creditPoints.forEach((element) => {
          var temp = [
            element.srNo,
            element.bookedBy,
            element.employeeName,
            element.meetingRoomName,
            element.dateOfMeeting,
            element.duration + ' ' + 'hours',
            element.creditPointsUsed,
            element.status,
          ];
          this.PdfReportrows.push(temp);
        });
        this.openPDF(
          this.PdfReportrows,
          'CreditPoint Admin(s) Report',
          head,
          'p'
        );
      }
    } else if (this.selectedIndex == 1) {
      let head = [
        [
          'Sr.No',
          'Member Name',
          'Department',
          'Access Point',
          'Date',
          'Check-in Time',
        ],
      ];

      this.checkIns.forEach((element) => {
        var temp = [
          element.srNo,
          element.memberName,
          element.designationName,
          element.accessPointName,
          element.date,
          element.timeOfCheckIn,
        ];
        this.PdfReportrows.push(temp);
      });
      this.openPDF(this.PdfReportrows, 'CheckIn Report', head, 'p');
    } else if (this.selectedIndex == 2) {
      let head = [
        [
          'Sr.No',
          'Member Name',
          'Department',
          'Onboarded Since',
          'Ph Number',
          'Email',
        ],
      ];

      this.employees.forEach((element) => {
        var temp = [
          element.srNo,
          element.memberName,
          element.department,
          element.onBoardDate,
          element.phoneNumber,
          element.email,
        ];
        this.PdfReportrows.push(temp);
      });
      this.openPDF(this.PdfReportrows, 'Employee Report', head, 'p');
    } else if (this.selectedIndex == 3) {
      let head = [
        [
          'Sr.No',
          'Meeting Room',
          'Membership type',
          'Organization Name',
          'Member Name',
          'Date',
          'Start Time',
          'Duration',
          'Status',
        ],
      ];

      this.meetings.forEach((element) => {
        var temp = [
          element.srNo,
          element.meetingRoomName,
          element.userType,
          element.organisation,
          element.employeeName,
          element.dateOfMeeting,
          element.startTime,
          element.duration + ' ' + 'hours',
          element.status,
        ];
        this.PdfReportrows.push(temp);
      });
      this.openPDF(this.PdfReportrows, 'Meeting Room Report', head, 'p');
    } else if (this.selectedIndex == 4) {
      let head = [
        [
          'Sr.No',
          'Meeting Room',
          'Membership type',
          'Organization Name',
          'Admin Name',
          'Member Name',
          'Date',
          'Start Time',
          'Duration',
          'Status',
        ],
      ];
      this.meetings.forEach((element) => {
        var temp = [
          element.srNo,
          element.meetingRoomName,
          element.userType,
          element.organisation,
          element.bookedBy,
          element.employeeName,
          element.dateOfMeeting,
          element.startTime,
          element.duration + ' ' + 'hours',
          element.status,
        ];
        this.PdfReportrows.push(temp);
      });
      this.openPDF(this.PdfReportrows, 'Meeting Room Report', head, 'p');
    }
  }
  openPDF(data, reportname, Head, orientation): void {
    var doc = new jsPDF({ orientation: orientation });

    doc.setFontSize(18);
    doc.text(reportname, 11, 8);
    doc.setFontSize(11);
    doc.setTextColor(100);

    (doc as any).autoTable({
      head: Head,
      body: data,
      columnWidth: '50%',
      theme: 'plain',
      styles: { cellWidth: 'auto', minCellWidth: 22 },
      didDrawCell: (data) => { },
    });

    // Open PDF in new tab via safe blob URL (avoids jsPDF dataurlnewwindow HTML injection)
    const pdfBlob = doc.output('blob');
    const blobUrl = URL.createObjectURL(pdfBlob);
    window.open(blobUrl, '_blank');

    // below line for Download PDF document
    doc.save(reportname + new Date().getTime());
  }

  public exportAsExcelFile(json: any[], excelFileName: string): void {
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
    const workbook: XLSX.WorkBook = {
      Sheets: { data: worksheet },
      SheetNames: ['data'],
    };
    const excelBuffer: any = XLSX.write(workbook, {
      bookType: 'xlsx',
      type: 'array',
    });
    this.saveAsExcelFile(excelBuffer, excelFileName);
  }
  private saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], { type: this.EXCEL_TYPE });
    const url = URL.createObjectURL(data);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName + '_export_' + new Date().getTime() + this.EXCEL_EXTENSION;
    a.click();
    URL.revokeObjectURL(url);
  }

  getPageLength() {
    if (!this.reportsLoaded) return 0;
    if (this.selectedIndex == 4) return this.meetings.length;
    if (this.selectedIndex == 3) return this.meetings.length;
    if (this.selectedIndex == 2) return this.employees.length;
    if (this.selectedIndex == 1) return this.checkIns.length;
    if (this.selectedIndex == 0) return this.creditPoints.length;
  }

  handlePageChangeMeeting(event) {
    this.page = event;
    console.log('pagination clicked');
    // this.meetingRoom = this.meetingRooms.map(
    //   (meeting: any, i: any) => ({ id: i + 1, ...meeting })).slice(
    //     (this.page - 1) * this.pageSize, (this.page - 1) * this.pageSize + this.pageSize);
    this.meeting = this.meetings.slice(
      0,
      this.meetings.length < 10
        ? this.meetings.length
        : (this.page - 1) * this.pageSize + this.pageSize
    );
  }

  handlePageChangeEmployee(event) {
    this.page = event;
    console.log('pagination clicked');
    // this.employee = this.employees.map(
    //   (dept: any, i: any) => ({ id: i + 1, ...dept })).slice(
    //     (this.page - 1) * this.pageSize, (this.page - 1) * this.pageSize + this.pageSize);
    this.employee = this.employees.slice(
      0,
      this.employees.length < 10
        ? this.employees.length
        : (this.page - 1) * this.pageSize + this.pageSize
    );
  }

  handlePageChangeCheckIn(event) {
    this.page = event;
    console.log('pagination clicked');
    // this.accessPoint = this.accessPoints.map(
    //   (access: any, i: any) => ({ id: i + 1, ...access })).slice(
    //     (this.page - 1) * this.pageSize, (this.page - 1) * this.pageSize + this.pageSize);
    this.checkIn = this.checkIns.slice(
      0,
      this.checkIns.length < 10
        ? this.checkIns.length
        : (this.page - 1) * this.pageSize + this.pageSize
    );
  }

  handlePageChangeCredit(event) {
    this.page = event;

    // this.creditPoint = this.creditPoints.map(
    //   (credit: any, i: any) => ({ id: i + 1, ...credit })).slice(
    //     (this.page - 1) * this.pageSize, (this.page - 1) * this.pageSize + this.pageSize);
    this.creditPoint = this.creditPoints.slice(
      0,
      this.creditPoints.length < 10
        ? this.creditPoints.length
        : (this.page - 1) * this.pageSize + this.pageSize
    );
  }

  convertTime(time) {
    this.hour = time.split(':')[0];
    this.min = time.split(':')[1];
    if (this.hour > 12) {
      this.meridiem = 'PM';
    } else this.meridiem = 'AM';
    this.time = this.hour + ':' + this.min + ' ' + this.meridiem;
    return this.time;
  }
  resetDate(id) {
    this.selectedDate = this.datepipe.transform(new Date(), 'MM/dd/yyyy');
    this.formattedSelectedDate = this.dateSrv.convertDateToLocaleString(new Date().getDate(), new Date().getMonth(), new Date().getFullYear());

    this.selectedToDate = this.datepipe.transform(new Date(), 'MM/dd/yyyy');
    this.formattedSelectedToDate = this.dateSrv.convertDateToLocaleString(new Date().getDate(), new Date().getMonth(), new Date().getFullYear());

    this.fDate = this.updateDateToCalendar();
    this.tDate = this.updateDateToCalendar();
    localStorage.setItem('temp', id);
    window.location.reload();
  }

  formatDate(date) {
    console.log(date)
    if (date.includes('/'))
      return this.dateSrv.convertDateToLocaleString(date.split('/')[1], date.split('/')[0] - 1, date.split('/')[2])
    else
      return this.dateSrv.convertDateToLocaleString(date.split('-')[1], date.split('-')[0] - 1, date.split('-')[2])
  }
}
